/**
 * @author : Abhishek N.
 * @description : Handles the submission of content, either from a file upload or text input, and performs various actions based on the input data.
 */

import { uploadText } from "../../api/uploadText";
import { franc } from "franc";
import removeAllHTMLTags from "../../utils/RemoveHtmlTags";
import { commonErrorToastMessage } from "../../components/toastify/AllToastifyErrors";
import { getDecrypted } from "../../utils/cryptoUtils";

/**
 *
 * @param {string} title - The title of the content.
 * @param {string} domain - The domain of the content.
 * @param {number} wordCount - The word count of the content.
 * @param {File} selectedFile - The selected file, if any.
 * @param {string} uploadedContent - The content uploaded from a file.
 * @param {string} content - The content from text input.
 * @param {function} setContent - A function to set the content.
 * @param {function} setIsLoading - A function to set loading state.
 * @param {function} setIsTextLoading - A function to set text loading state.
 * @param {function} setTitle - A function to set the title.
 * @param {function} setIsNetworkError - A function to set network error state.
 * @param {function} setResponseData - A function to set response data.
 * @param {RefObject} titleInputRef - A reference to the title input element.
 * @param {RefObject} .domainSelectRef - A reference to the domain select element.
 * @param {function} params.navigate - A function for navigation.
 * @param {any} params.response - The response data (if any).
 */


export const handleSubmitContent = async ({
  title,
  domain,
  wordCount,
  selectedFile,
  uploadedContent,
  content,
  setContent,
  setIsLoading,
  setIsTextLoading,
  setTitle,
  setDomain,
  setIsNetworkError,
  setResponseData,
  titleInputRef,
  domainSelectRef,
  navigate,
  response,
}) => {

  // Check if domain is empty
  if (!domain) {
    setDomain('other')
  }

  // Check if word count is less than 300
  if (wordCount < 300 || wordCount > 15000) {
    commonErrorToastMessage(
      "Word count must be between 300-15000 for question generation."
    );
    return;
  }

  // Check if text is in English or not
  
  const text = content;

  if (text) {
    const languageCode = franc(text, { minLength: 100 }); // Minimum length to consider for language detection
    if (languageCode !== "eng") {
      commonErrorToastMessage(
        "Kindly input text written in the English language exclusively."
      );

      setIsLoading(false);

      return content; // Return the existing content if the file size exceeds the limit
    }
  }

  try {
    setIsLoading(true);
    window.title = title;

    if (selectedFile) {
      // Handle file upload
      setContent(uploadedContent);
      setTitle(title);
      setResponseData(response.data);
    } else if (content) {
      // Handle text input
      setIsTextLoading(true);

      // This is mechanism is only for Sample Text
      const isSampleTextClicked = localStorage.getItem("isSampleButtonClicked");

       // ✅ Decrypt email — replaces plain localStorage.getItem("email")
      const email = await getDecrypted("email");


      const sector_name  = 'Financial';

      const word_count = wordCount;

      // Upload text text API call
      let response = "";
       let filteredContent = ""; 
      if (isSampleTextClicked === "true") {
        filteredContent = await removeAllHTMLTags (content);
        const payload = {
          content: filteredContent,
          title,
          email,
          word_count,
          sector_name,
        };
      } else {
         filteredContent = await removeAllHTMLTags (content);
         const payload = {
    content: filteredContent, 
    title,
    email,
    word_count,
    sector_name
  };
         
        const uploadTextResponse = await uploadText(payload);
        response = uploadTextResponse;
         if (response !== null) {
          localStorage.setItem('QAreqbody',JSON.stringify(response?.data))
          setContent(response);
        }
      }

      setResponseData(response.data);

      navigate(`/QuestionsSelection`);
      setIsTextLoading(false);
    }

    setIsLoading(false);
  } catch (error) {
    alert('Error form HS')
    // Handle network error
    setIsNetworkError(true);
    setIsLoading(false);
    setIsTextLoading(false);
    console.error("Error while making the API request:", error);
    commonErrorToastMessage("Error.");
  } finally {
    if (!selectedFile) {
      setIsLoading(false);
    }
  }
};
